/**
 * DEA registration number check, mirroring app-service `utils/user/dea.py`.
 * A registrant-type letter, then a last-name initial or '9' (business /
 * no initial), then seven digits; (d1+d3+d5) + 2*(d2+d4+d6) must end in d7.
 * The registration lookup that rejects '9' in the second position is MDG-358.
 */
const DEA_FORMAT = /^[A-Z][A-Z9]\d{7}$/;

export function isValidDeaNumber(value: string | null | undefined): boolean {
  const candidate = (value ?? '').trim().toUpperCase();
  if (!DEA_FORMAT.test(candidate)) {
    return false;
  }
  const d = candidate.slice(2).split('').map(Number);
  const total = d[0] + d[2] + d[4] + 2 * (d[1] + d[3] + d[5]);
  return total % 10 === d[6];
}
